import _ from 'underscore';
import $ from 'jquery';
import Constants from 'root/constants';
import Cache from 'root/cache';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    events: {
        'click .dropdown-role li'           : 'onEditRole',
        'click .dropdown-project-access li' : 'onSelectProjectAccess',
        'click .session-replay-access'      : 'onToggleSessionReplayAccess',
    },

    dom_handlers: {
        onEditRole: function(e) {
            var role = $(e.currentTarget).data('val');

            if (!Cache.account.hasFeature('client_role') && role === Constants.CLIENT) {
                Modals.unlockFeature();
            }

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            Cache.app.request({
                action: 'workspace_member/update',
                data: {
                    id: this.model.id,
                    role: role
                },
                success: (response) => {
                    this.model.set('role', response.role);

                    if (role === Constants.CLIENT) {
                        Cache.project.each((project_model) => {
                            project_model.set({
                                default_assignee_id_bug     : 0,
                                default_assignee_id_feature : 0,
                                default_assignee_id_general : 0,
                            });
                        });
                    }

                    UI.success('Member role updated');
                }
            });
        },

        onSelectProjectAccess: function(e) {
            if (this.model.get('role') === Constants.ADMIN) {
                return;
            }

            var project_id = $(e.currentTarget).data('val');
            var add_access = $(e.currentTarget).hasClass('selected') ? false : true;

            Cache.app.request({
                action: add_access ? 'project_access/create' : 'project_access/delete',
                data: {
                    project_id: project_id,
                    user_id: this.model.get('user_id')
                },
                success: (response) => {
                    if (add_access) {
                        Cache.project_access.add(response);
                    } else {
                        Cache.project_access.searchAndRemove({
                            project_id: project_id,
                            user_id: this.model.get('user_id')
                        });
                    }

                    UI.success('Project access updated');
                }
            });
        },

        onToggleSessionReplayAccess: function(e) {
            var has_access = $(e.currentTarget).prop('checked');

            this.model.setAccess(Constants.ACCESS_SESSION_REPLAY, has_access ? 1 : 0, 0);

            UI.success('Sessions access updated');
        },
    },

    event_handlers: {
        onProjectAccessChange: function(model) {
            if (this.model.get('user_id') === model.get('user_id')) {
                this.render();
            }
        }
    },

    initialize: function() {
        this.user = Cache.user.get(this.model.get('user_id'));

        this.listenTo(this.model, 'change', this.render);
        this.listenTo(Cache.project_access, 'add',    this.event_handlers.onProjectAccessChange);
        this.listenTo(Cache.project_access, 'remove', this.event_handlers.onProjectAccessChange);
    },

    render: function() {
        var can_edit_role = (this.user.id === Cache.real_user_id ? false : !this.model.get('is_disabled'));
        var can_edit_project_access = this.model.get('role') !== Constants.ADMIN && !this.model.get('is_disabled');
        var uid = _.uniqueId('session_replay_access_');
        var project_options = '';
        var access_total = 0;

        Cache.project.where({is_archived: false}).forEach((project_model) => {
            var has_access = false;

            if (this.model.get('role') === Constants.ADMIN) {
                has_access = true;
            } else if (Cache.project_access.where({project_id: project_model.id, user_id: this.model.get('user_id')}).length) {
                has_access = true;
            }

            if (!Cache.account.hasFeature('user_restriction')) {
                has_access = true;
            }

            if (has_access) {
                access_total++;
            }

            var class_names = [];
            if (has_access) {
                class_names.push('selected');
            }
            if (!can_edit_project_access) {
                class_names.push('disabled');
            }

            project_options +=
            '<li class="' + class_names.join(' ') + '" data-val="' + project_model.id + '">' +
                '<div class="flex-start">' +
                    (project_model.get('logo') ?
                    '<span class="project-logo-icon-tiny" style="background-image:url(' + project_model.escape('logo') + ');"></span>' :
                    '<span class="project-type-icon-tiny" data-val="' + (project_model.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                    '<span class="ellipsis margin-left-8">' + project_model.escape('name') + '</span>' +
                '</div>' +
            '</li>';
        });

        var content =
        '<form class="form-fluid">' +
            // role
            '<div class="row">' +
                '<div class="field-label">Select a role</div>' +
                '<div class="button-dropdown button-dropdown-xlarge button-dropdown-full">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium">' +
                        (this.model.get('role') === Constants.ADMIN    ? 'Administrator' : '') +
                        (this.model.get('role') === Constants.ASSIGNEE ? 'Collaborator'  : '') +
                        (this.model.get('role') === Constants.CLIENT   ? 'Guest'         : '') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-role">' +
                            '<li class="' + (this.model.get('role') === Constants.ADMIN ? 'selected' : '') + (!can_edit_role || this.model.get('is_owner') ? ' disabled' : '') + '" data-val="' + Constants.ADMIN + '">' +
                                '<div class="font-weight-medium">Administrator</div>' +
                                '<div class="desc-text">Manage account settings, workspaces and billing</div>' +
                            '</li>' +
                            '<li class="' + (this.model.get('role') === Constants.ASSIGNEE ? 'selected' : '') + (!can_edit_role || this.model.get('is_owner') ? ' disabled' : '') + '" data-val="' + Constants.ASSIGNEE + '">' +
                                '<div class="font-weight-medium">Collaborator</div>' +
                                '<div class="desc-text">Manage feedback and survey responses for one or more projects</div>' +
                            '</li>' +
                            '<li class="' + (this.model.get('role') === Constants.CLIENT ? 'selected' : '') + (!can_edit_role || this.model.get('is_owner') || !Cache.account.hasFeature('client_role') ? ' disabled' : '') + '" data-val="' + Constants.CLIENT + '">' +
                                '<div class="font-weight-medium">Guest' + (Cache.account.hasFeature('client_role') ? '' : ' <i class="fa-solid fa-lock-keyhole text-warning fa-xs"></i>') + '</div>' +
                                '<div class="desc-text">View feedback and survey responses and track their feedback</div>' +
                            '</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            // project access
            '<div class="row">' +
                '<div class="field-label">Select projects to grant access</div>' +
                (Cache.account.hasFeature('user_restriction') ?
                // has user restriction feature
                '<div class="button-dropdown button-dropdown-xlarge button-dropdown-full">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"' + (can_edit_project_access ? '' : ' disabled') + '>' +
                        (this.model.get('role') === Constants.ADMIN ? 'All Projects' :
                        access_total + ' Project' + (access_total === 1 ? '' : 's')) +
                    '</button>' +
                    '<div>' +
                        (Cache.project.where({is_archived: false}).length >= 10 ?
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by project name">' +
                        '</div>' : '') +
                        '<ul class="dropdown dropdown-select dropdown-project-access">' +
                            project_options +
                        '</ul>' +
                    '</div>' +
                '</div>'
                :
                // no user restriction feature
                '<div class="button-dropdown button-dropdown-full">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium tooltip" data-title="Project access is not available in your account plan">All Projects</button>' +
                '</div>') +
            '</div>' +


            // session replay access
            (Cache.account.hasFeature('full_session_recording') && this.model.get('role') !== Constants.CLIENT ?
            '<div class="row">' +
                '<input id="' + uid + '" class="session-replay-access" type="checkbox"' + (this.model.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ? ' checked' : '') + (this.model.get('role') === Constants.ADMIN ? ' disabled' : '') + '>' +
                '<label for="' + uid +'">Grant access to all sessions</label>' +
            '</div>' : '') +

            (this.model.get('role') === Constants.ADMIN ?
            '<div class="text-info text-medium margin-top-8"><i class="fa-solid fa-circle-info text-icon"></i> Admin user has access to all the projects' + (Cache.account.hasFeature('full_session_recording') ? ' & sessions' : '') + '</div>' : '')
        '</form>';

        this.$el.html(content);

        return this;
    }
});